<template>
  <div class="upload">
    <div class="example-btn">
      <file-upload class="btn btn-success"
                    :post-action="url"
                    extensions="pdf"
                    accept="application/pdf"
                    :size="1024 * 1024 * 10"
                    v-model="files"
                    @input-file="inputFile"
                    ref="upload"
                    :disabled="disabled || ($refs.upload && $refs.upload.active)">{{uploadText}}
      </file-upload>
    </div>
  </div>
</template>

<script>
  import FileUpload from 'vue-upload-component'

  export default {
    props: {
      url: {
        type: String,
      },
      disabled: {
        type: Boolean
      },
      uploadText: {
        type: String,
        default: 'Upload'
      }
    },

    components: {
      FileUpload,
    },

    data() {
      return {
        files: [],
      }
    },

    methods: {
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile)
          this.$refs.upload.active = true;
        else if (newFile.success !== oldFile.success)
          this.$emit("file-uploaded");
      }
    }
  }
</script>